// js/utils.js
/**
 * Creates a smooth SVG path data string (d attribute) using Catmull-Rom to Cubic Bezier conversion.
 * @param {Array<{x: number, y: number}>} pts - Array of points the curve should pass through/near.
 * @param {number} [tension=0.5] - Controls the tightness of the curve. 0 is linear, 1 is tighter.
 * @returns {string} The SVG path data string.
 */ function $a6df9c40ba402dc9$export$a0228848244ce699(pts, tension = 0.5) {
    if (!pts || pts.length < 2) return "";
    let d = `M${pts[0].x},${pts[0].y}`; // Start moveTo
    // Iterate through the segments of the curve
    for(let i = 0; i < pts.length - 1; i++){
        // Determine control points p0, p1, p2, p3 for the Catmull-Rom spline segment
        // Handle boundary conditions: if points don't exist, reuse adjacent points
        const p0 = i === 0 ? pts[i] : pts[i - 1];
        const p1 = pts[i];
        const p2 = pts[i + 1];
        const p3 = i + 2 < pts.length ? pts[i + 2] : p2; // Reuse p2 if p3 is out of bounds
        // Calculate the cubic Bezier control points (cp1, cp2) for the segment from p1 to p2
        // Formula derived from the Catmull-Rom spline definition
        const cp1x = p1.x + (p2.x - p0.x) * tension / 6;
        const cp1y = p1.y + (p2.y - p0.y) * tension / 6;
        const cp2x = p2.x - (p3.x - p1.x) * tension / 6;
        const cp2y = p2.y - (p3.y - p1.y) * tension / 6;
        // Append the cubic Bezier segment to the path data string
        d += `C${cp1x},${cp1y} ${cp2x},${cp2y} ${p2.x},${p2.y}`;
    }
    return d;
}
function $a6df9c40ba402dc9$export$508749e9bc90f717(p1, p2, numPoints = 3, amplitude = 40) {
    const intermediatePoints = [];
    const deltaX = p2.x - p1.x;
    const deltaY = p2.y - p1.y;
    const totalDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    // Calculate a normalized perpendicular vector
    let perpX = -deltaY;
    let perpY = deltaX;
    if (totalDistance > 0) {
        const len = Math.sqrt(perpX * perpX + perpY * perpY);
        if (len > 0) {
            perpX /= len;
            perpY /= len;
        } else {
            perpX = 0;
            perpY = 0;
        }
    } else {
        perpX = 0;
        perpY = 0;
    }
    for(let i = 1; i <= numPoints; i++){
        const fraction = i / (numPoints + 1);
        const lineX = p1.x + fraction * deltaX;
        const lineY = p1.y + fraction * deltaY;
        const currentAmplitude = amplitude * Math.sin(fraction * Math.PI); // Sine variation
        const sign = i % 2 === 1 ? 1 : -1; // Alternate offset direction
        const offsetX = sign * currentAmplitude * perpX;
        const offsetY = sign * currentAmplitude * perpY;
        intermediatePoints.push({
            x: lineX + offsetX,
            y: lineY + offsetY
        });
    }
    return intermediatePoints;
} // NOTE: The other functions from your provided file are not needed for this specific animation,
 // but are kept here in case of future use.
 // --- REST OF THE FILE UNCHANGED ---


let $54b47fc030b7b21e$var$cache = {};
const $54b47fc030b7b21e$var$highlighter = document.getElementById('line-highlighter');
const $54b47fc030b7b21e$var$svgLayer = document.getElementById('svg-layer');
function $54b47fc030b7b21e$var$moveHighlight(line) {
    if (line === null) {
        $54b47fc030b7b21e$var$highlighter.style.opacity = 0;
        return;
    }
    const lineHeight = 21;
    const paddingTop = 16;
    $54b47fc030b7b21e$var$highlighter.style.opacity = 1;
    $54b47fc030b7b21e$var$highlighter.style.top = `${(line - 1) * lineHeight + paddingTop}px`;
}
async function $54b47fc030b7b21e$var$travel(from, to, color = "#ff4757") {
    return new Promise((resolve)=>{
        const r1 = from.getBoundingClientRect();
        const r2 = to.getBoundingClientRect();
        const sX = window.scrollX;
        const sY = window.scrollY;
        const p1 = {
            x: r1.left + sX + r1.width / 2,
            y: r1.top + sY + r1.height / 2
        };
        const p2 = {
            x: r2.left + sX + r2.width / 2,
            y: r2.top + sY + r2.height / 2
        };
        const pathData = (0, $a6df9c40ba402dc9$export$a0228848244ce699)([
            p1,
            ...(0, $a6df9c40ba402dc9$export$508749e9bc90f717)(p1, p2, 2, 40),
            p2
        ]);
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", pathData);
        path.setAttribute("stroke", color);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke-width", "2");
        path.setAttribute("opacity", "0.3");
        $54b47fc030b7b21e$var$svgLayer.appendChild(path);
        const dot = document.createElement('div');
        dot.className = 'moving-dot';
        dot.style.background = color;
        document.body.appendChild(dot);
        let prog = 0;
        const len = path.getTotalLength();
        function frame() {
            prog += 0.025;
            if (prog <= 1) {
                const pt = path.getPointAtLength(prog * len);
                dot.style.left = `${pt.x - 6}px`;
                dot.style.top = `${pt.y - 6}px`;
                requestAnimationFrame(frame);
            } else {
                dot.remove();
                setTimeout(()=>path.remove(), 500);
                resolve();
            }
        }
        frame();
    });
}
function $54b47fc030b7b21e$var$internalFibFast(n) {
    if (n in $54b47fc030b7b21e$var$cache) return $54b47fc030b7b21e$var$cache[n];
    if (n === 0) {
        $54b47fc030b7b21e$var$cache[0] = 0;
        $54b47fc030b7b21e$var$updateCacheUI();
        return 0;
    }
    if (n === 1) {
        $54b47fc030b7b21e$var$cache[0] = 0;
        $54b47fc030b7b21e$var$cache[1] = 1;
        $54b47fc030b7b21e$var$updateCacheUI();
        return 1;
    }
    $54b47fc030b7b21e$var$cache[n] = $54b47fc030b7b21e$var$internalFibFast(n - 1) + $54b47fc030b7b21e$var$internalFibFast(n - 2);
    $54b47fc030b7b21e$var$updateCacheUI();
    return $54b47fc030b7b21e$var$cache[n];
}
async function $54b47fc030b7b21e$var$internalFibDetailed(n) {
    const monitorStatus = document.getElementById('monitor-status');
    const monitorAction = document.getElementById('monitor-action');
    const stackContainer = document.getElementById('stack-container');
    const leftEl = document.getElementById('left-branch');
    const rightEl = document.getElementById('right-branch');
    const stackItem = document.createElement('div');
    stackItem.className = 'stack-item';
    stackItem.innerText = `fib(${n}) - Pending`;
    stackContainer.appendChild(stackItem);
    $54b47fc030b7b21e$var$moveHighlight(15);
    monitorStatus.innerText = `Level ${stackContainer.children.length}: n = ${n}`;
    monitorAction.innerText = `Entering fib(${n})...`;
    await new Promise((r)=>setTimeout(r, 200));
    $54b47fc030b7b21e$var$moveHighlight(16);
    if (n in $54b47fc030b7b21e$var$cache) {
        monitorAction.innerText = `HIT! Using cached value: ${$54b47fc030b7b21e$var$cache[n]}`;
        await new Promise((r)=>setTimeout(r, 300));
        stackContainer.removeChild(stackItem);
        return $54b47fc030b7b21e$var$cache[n];
    }
    $54b47fc030b7b21e$var$moveHighlight(17);
    if (n === 0) {
        $54b47fc030b7b21e$var$cache[0] = 0;
        $54b47fc030b7b21e$var$updateCacheUI();
        stackContainer.removeChild(stackItem);
        return 0;
    }
    $54b47fc030b7b21e$var$moveHighlight(18);
    if (n === 1) {
        $54b47fc030b7b21e$var$cache[0] = 0;
        $54b47fc030b7b21e$var$cache[1] = 1;
        $54b47fc030b7b21e$var$updateCacheUI();
        stackContainer.removeChild(stackItem);
        return 1;
    }
    $54b47fc030b7b21e$var$moveHighlight(23);
    leftEl.innerText = `fib(${n - 1})`;
    leftEl.className = "branch-slot active-branch";
    rightEl.innerText = `fib(${n - 2})`;
    const val1 = await $54b47fc030b7b21e$var$internalFibDetailed(n - 1);
    $54b47fc030b7b21e$var$moveHighlight(23);
    leftEl.innerText = val1;
    leftEl.className = "branch-slot resolved-branch";
    rightEl.className = "branch-slot active-branch";
    const val2 = await $54b47fc030b7b21e$var$internalFibDetailed(n - 2);
    $54b47fc030b7b21e$var$moveHighlight(24);
    rightEl.innerText = val2;
    rightEl.className = "branch-slot resolved-branch";
    const res = val1 + val2;
    $54b47fc030b7b21e$var$cache[n] = res;
    $54b47fc030b7b21e$var$updateCacheUI();
    await new Promise((r)=>setTimeout(r, 300));
    stackContainer.removeChild(stackItem);
    return res;
}
async function $54b47fc030b7b21e$var$run() {
    const inputEl = document.getElementById('arg-input');
    const n = parseInt(inputEl.value);
    const showDetails = document.getElementById('recursion-toggle').checked;
    if (showDetails && n > 31) {
        alert("Recursion details are limited to n <= 31.");
        return;
    }
    document.getElementById('check-n').innerText = n;
    document.getElementById('heavy-n').innerText = n;
    const checkBox = document.getElementById('check-box');
    const heavyBox = document.getElementById('heavy-func-box');
    const processor = document.getElementById('processor');
    const cacheBox = document.getElementById('cache-box');
    const returnBox = document.getElementById('return-box');
    const recBox = document.getElementById('recursion-details');
    $54b47fc030b7b21e$var$moveHighlight(5);
    await $54b47fc030b7b21e$var$travel(inputEl, checkBox);
    if ($54b47fc030b7b21e$var$cache[n] !== undefined) {
        $54b47fc030b7b21e$var$moveHighlight(6);
        await $54b47fc030b7b21e$var$travel(checkBox, cacheBox, "#2ecc71");
        await $54b47fc030b7b21e$var$travel(cacheBox, returnBox, "#2ecc71");
        document.getElementById('return-val').innerText = `Fib(${n}) = ${$54b47fc030b7b21e$var$cache[n]}`;
    } else {
        document.getElementById('ProcessingMsg').innerText = " ...Updating Cache...";
        $54b47fc030b7b21e$var$moveHighlight(9);
        await $54b47fc030b7b21e$var$travel(checkBox, heavyBox, "#e74c3c");
        processor.classList.add('processing');
        // Allow DOM to update (show text and start rotation)
        await new Promise((r)=>setTimeout(r, 50));
        let res;
        if (showDetails) {
            await $54b47fc030b7b21e$var$travel(heavyBox, recBox, "#e67e22");
            res = await $54b47fc030b7b21e$var$internalFibDetailed(n);
        } else res = $54b47fc030b7b21e$var$internalFibFast(n);
        document.getElementById('ProcessingMsg').innerText = "";
        processor.classList.remove('processing');
        $54b47fc030b7b21e$var$moveHighlight(10);
        await $54b47fc030b7b21e$var$travel(showDetails ? recBox : heavyBox, cacheBox, "#9b59b6");
        $54b47fc030b7b21e$var$updateCacheUI();
        $54b47fc030b7b21e$var$moveHighlight(11);
        await $54b47fc030b7b21e$var$travel(cacheBox, returnBox, "#2ecc71");
        document.getElementById('return-val').innerText = `Fib(${n}) = ${res}`;
    }
    setTimeout(()=>$54b47fc030b7b21e$var$moveHighlight(null), 1000);
}
function $54b47fc030b7b21e$var$updateCacheUI() {
    const container = document.getElementById('cache-contents');
    const scrollArea = document.getElementById('cache-scroll-area');
    container.innerHTML = Object.entries($54b47fc030b7b21e$var$cache).sort((a, b)=>a[0] - b[0]).map(([k, v])=>`<div class="cache-entry">"${k}": ${v}</div>`).join('');
    scrollArea.scrollTop = scrollArea.scrollHeight;
}
function $54b47fc030b7b21e$var$resetAll() {
    $54b47fc030b7b21e$var$cache = {};
    $54b47fc030b7b21e$var$updateCacheUI();
    document.getElementById('return-val').innerText = "---";
    document.getElementById('ProcessingMsg').innerText = "";
    document.getElementById('left-branch').innerText = "fib(n-1)";
    document.getElementById('right-branch').innerText = "fib(n-2)";
    document.getElementById('left-branch').className = "branch-slot";
    document.getElementById('right-branch').className = "branch-slot";
    document.getElementById('stack-container').innerHTML = "";
    document.getElementById('monitor-status').innerText = "Standing by...";
    document.getElementById('monitor-action').innerText = "";
    $54b47fc030b7b21e$var$svgLayer.innerHTML = "";
    $54b47fc030b7b21e$var$moveHighlight(null);
    document.getElementById('processor').classList.remove('processing');
}
function $54b47fc030b7b21e$var$toggleDetails() {
    const isChecked = document.getElementById('recursion-toggle').checked;
    const stackBox = document.getElementById('stack-box');
    const recBox = document.getElementById('recursion-details');
    if (isChecked) {
        stackBox.classList.remove('details-hidden');
        recBox.classList.remove('details-hidden');
    } else {
        stackBox.classList.add('details-hidden');
        recBox.classList.add('details-hidden');
    }
}
document.getElementById('run-btn').addEventListener('click', $54b47fc030b7b21e$var$run);
document.getElementById('clear-btn').addEventListener('click', $54b47fc030b7b21e$var$resetAll);
document.getElementById('recursion-toggle').addEventListener('change', $54b47fc030b7b21e$var$toggleDetails);
$54b47fc030b7b21e$var$toggleDetails();


//# sourceMappingURL=Visualizer_Memoize.7a84a8f6.js.map
